import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigurationService, RoleListDto } from '../configuration.service';
import { AuthService } from '../../services/auth.service';
import { RoleEditComponent, RoleEditDialogData } from './role-edit.component';

@Component({
  selector: 'app-configuration-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['../configuration-list.css'],
})
export class ConfigurationRolesComponent implements OnInit {
  roles: RoleListDto[] = [];
  loading = false;
  search = '';

  constructor(
    private api: ConfigurationService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    public auth: AuthService
  ) {}

  ngOnInit(): void { this.load(); }

  load(): void {
    if (!this.roles.length) this.loading = true;
    this.api.getRoles().subscribe({
      next: r => { this.roles = r; this.loading = false; },
      error: () => { this.loading = false; this.snackBar.open('Failed to load roles', undefined, { duration: 4000 }); }
    });
  }

  trackById(_: number, r: RoleListDto): number { return r.id; }

  get filtered(): RoleListDto[] {
    const q = this.search.trim().toLowerCase();
    return q ? this.roles.filter(r => r.name.toLowerCase().includes(q)) : this.roles;
  }

  createRole(): void { this.openEditor(null); }

  editRole(id: number): void { this.openEditor(id); }

  private openEditor(roleId: number | null): void {
    const ref = this.dialog.open<RoleEditComponent, RoleEditDialogData, boolean>(
      RoleEditComponent,
      { width: '760px', maxWidth: '92vw', data: { roleId } }
    );
    ref.afterClosed().subscribe(saved => { if (saved) this.load(); });
  }

  deleteRole(role: RoleListDto): void {
    if (role.isSystemDefault) {
      const typedName = prompt(`This is a system default role. Type "${role.name}" to confirm deletion:`);
      if (typedName !== role.name) return;
    } else {
      if (!confirm(`Delete ${role.name}? This cannot be undone.`)) return;
    }
    this.api.deleteRole(role.id).subscribe({
      next: () => this.load(),
      error: () => this.snackBar.open('Failed to delete role', undefined, { duration: 4000 })
    });
  }
}
